import { render, staticRenderFns } from "./MainError.vue?vue&type=template&id=fd22ced6&scoped=true&"
import script from "./MainError.vue?vue&type=script&lang=js&"
export * from "./MainError.vue?vue&type=script&lang=js&"
import style1 from "./MainError.vue?vue&type=style&index=1&id=fd22ced6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd22ced6",
  null
  
)

export default component.exports